import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

export default function LinkHistory() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [phid, setphid] = useState("");
  const [ghid, setghid] = useState("");

  const referral_API = async () => {
    setisLoading(true);
    try {
      let response = await API?.post(
        "/PendingPHHistory",
        {
          loginid: userId,
          type: "PendingPhLinkHistory",
          phid: phid,
          ghid: ghid,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //console.log("response", response);
      const data = response?.data?.data?.[0] || [];
      const cleanedData = data.map((item) => ({
        sr: item.rownumber,
        id: item?.rowid,
        gh: item?.GH,
        ph: item?.PH,
        Link_Amount: item?.Amount,
        Link_Type: item?.Link_Type,
        PHPaid_Status:
          item?.PHPaid_Status == "Pending PH" ? (
            <span style={{ color: "red" }}>{item?.PHPaid_Status}</span>
          ) : (
            <span style={{ color: "green" }}>{item?.PHPaid_Status}</span>
          ),
        GHPaid_Status:
          item?.GHPaid_Status == "Pending GH" ? (
            <span style={{ color: "red" }}>{item?.GHPaid_Status}</span>
          ) : (
            <span style={{ color: "green" }}>{item?.GHPaid_Status}</span>
          ),
        LinkDate: item?.LinkDate,
      }));

      setleftreferralApi(cleanedData);
    } catch (e) {
      console.log("Error in referral_API", e);
      if (
        e.response?.data?.showableMessage ===
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  const CancelLinkId_Api = async (id) => {
    try {
      if (window.confirm("Are you sure, you want to cancel..?")) {
        let response = await API?.post(
          "/CancelPendingPhLink",
          {
            loginid: userId,
            id: id,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );

        const result = response?.data?.data?.result;
        if (result === "Link Canceled !!") {
          toast.success("Link Canceled Successfully !!");
          referral_API();
        } else {
          toast.error(result);
        }
      }
    } catch (e) {
      console.log("Error in UpdateLinkId_Api", e);
      if (
        e.response?.data?.showableMessage ===
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  const displayData = currentPostleft.map((item) => ({
    ...item,
    update: (
      <button
        type="button"
        className="btn btn-success btn-sm"
        onClick={() => CancelLinkId_Api(item.id)}
      >
        Cancel
      </button>
    ),
  }));

  const my_team = {
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "Cancel", accessor: "update" },
      { Header: "GH", accessor: "gh" },
      { Header: "PH", accessor: "ph" },
      { Header: "Amount", accessor: "Link_Amount" },
      { Header: "Link Type", accessor: "Link_Type" },
      { Header: "PH Paid Status", accessor: "PHPaid_Status" },
      { Header: "GH Paid Status", accessor: "GHPaid_Status" },
      { Header: "Link Date", accessor: "LinkDate" },
    ],
  };

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="panel panel-primary">
                <div className="panel-heading">
                  <h4 className="panel-title"> Pending PH History</h4>
                </div>
                <div className="row" style={{ marginLeft: "10px" }}>
                  <div className="col-md-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter PH"
                      onChange={(e) => setphid(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter GH"
                      onChange={(e) => setghid(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => referral_API()}
                    >
                      Search
                    </button>
                  </div>
                </div>
                <div className="panel-body">
                  <div className="row">
                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={displayData} columns={my_team.cols} />
                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
